import React , {useEffect}  from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import image1 from '../../assets/images/homeDestinations/faragki-enipea.jpg'
import image2 from '../../assets/images/homeDestinations/mountains-pieria.jpg'
import image3 from '../../assets/images/homeDestinations/Olympos_Wasserfall.jpg'
import image4 from '../../assets/images/homeDestinations/platamonas-beach.jpg'
import image5 from '../../assets/images/homeDestinations/panoramic-Litohoro.jpg'
import Aos from "aos";
import 'aos/dist/aos.css';

const Container = styled.div`
    display:flex;
    flex-direction: column;
    margin-bottom: 100px;

  @media (max-width: 480px) {
    font-size: 18px;
    margin-bottom: 80px;
    place-self:center;
  }
`;

const Title = styled.div`
   font-size: 40px;
   display:flex;
   color: #385963;
   font-weight: 600;
   margin-bottom: 10px;

     @media (max-width: 768px) {
    font-size: 25px;
    margin-bottom: 20px;
    place-self:center;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    margin-bottom: 20px;
    place-self:center;
  }
`;

const Description = styled.div`
   font-size: 20px;
   margin-bottom: 20px;
   color:#91abb3;
 
  @media (max-width: 768px) {
    font-size: 14px;
    margin: 10px 20px 80px;
    text-align:center;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin: 10px 10px 50px;
    text-align:center;
  }
`;

const Grid = styled.div`

    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(auto-fit,minmax(200px,1fr));
    grid-auto-rows:300px;
    grid-auto-flow: dense;

   > div{
    display:flex;
    justify-content: center;
    align-items: center;
  }

   img{
     width: 100%;
     height:100%;
     object-fit: cover;
     border-radius: 5px;
    //  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
    //  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
    
    &:hover {
        box-shadow: rgba(0, 0, 0, 0.3) 0px 30px 90px;
        transition:  0.7s;
      }
   }

`;

// const MoreButton = styled.div`
//     // color: #385963;
//     // font-size: 20px;
//     background-color: #91abb3;
//     color: white;
//     border:none;
//     width: 120px;
//     padding: 5px;
//     display: flex;
//     justify-content: center;
//     border-radius: 10px;
//     // border: solid 2px  #385963;

//     &:hover {
//         box-shadow: rgba(0, 0, 0, 0.6) 0px 10px 60px;
//         transition:  0.4s;
//         cursor: pointer;
//        background-color: #385963;
//       }
// `;

const MoreButton = styled.div`
    background-color: white;
    color: #385963;
    font-weight:400;
    border:  #385963 solid 2px;
    width: 120px;
    padding: 5px;
    display: flex;
    justify-content: center;
    border-radius: 10px;
    // border: solid 2px  #385963;

    &:hover {
      //   box-shadow: rgba(0, 0, 0, 0.6) 0px 10px 60px;
      //   transition:  0.4s;
      //   cursor: pointer;
      //  background-color: #385963;
      box-shadow: rgba(0, 0, 0, 0.6) 0px 10px 50px;
       color:white;
       transition:  0.4s;
       cursor: pointer;
      background-color: #385963;
      }
`;

const ButtonWrapper = styled.div`
    display:flex;
    justify-content: center;
    margin: 50px;
    margin-bottom: 0px;
`;



const InstagramFeedHome = () => {

  useEffect(()=>{
    Aos.init({duration:1000})
  },[]);

    const { i18n } = useTranslation();

  return (
    <Container>
        <Title data-aos="zoom-in-down">{i18n.t('instagramFeed')}</Title>
        <div data-aos="fade-right">
         <Description >{i18n.t('hashtag')}</Description>
         <Grid >
             <div><img src={image1}/></div>
             <div><img src= {image2}/></div>
             <div><img src={image3}/></div>
             <div><img src= {image4}/></div>
             <div><img src={image5}/></div>
         </Grid>
           <ButtonWrapper >
             <MoreButton>{i18n.t('loadMore')}</MoreButton>
           </ButtonWrapper>
        </div> 
    </Container>
  )
}

export default InstagramFeedHome
